const dragContainer = document.querySelector(
    '[high-quality-drag-container]',
) as HTMLElement
if (dragContainer) {
    dragContainer.scrollLeft =
        (dragContainer.scrollWidth -
            dragContainer.clientWidth) /
        2

    // const wrapper = document.querySelector('.wrapper');

    let isDown = false
    let startX: Number
    let scrollLeft: Number

    // obsługa myszy
    dragContainer.addEventListener('mousedown', (e) => {
        isDown = true
        dragContainer.classList.add('dragging')
        startX = e.pageX - dragContainer.offsetLeft
        scrollLeft = dragContainer.scrollLeft
    })

    dragContainer.addEventListener('mouseleave', () => {
        isDown = false
        dragContainer.classList.remove('dragging')
    })

    dragContainer.addEventListener('mouseup', () => {
        isDown = false
        dragContainer.classList.remove('dragging')
    })

    dragContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault() // blokuje zaznaczanie tekstu
        const x = e.pageX - dragContainer.offsetLeft
        const walk = x - startX // różnica
        dragContainer.scrollLeft = scrollLeft - walk
    })

    // obsługa dotyku
    dragContainer.addEventListener(
        'touchstart',
        (e) => {
            isDown = true
            startX = e.touches[0].pageX - dragContainer.offsetLeft
            scrollLeft = dragContainer.scrollLeft
        },
        { passive: true },
    )

    dragContainer.addEventListener('touchend', () => {
        isDown = false
    })

    dragContainer.addEventListener(
        'touchmove',
        (e) => {
            if (!isDown) return
            const x = e.touches[0].pageX - dragContainer.offsetLeft
            const walk = x - startX
            dragContainer.scrollLeft = scrollLeft - walk
        },
        { passive: true },
    )
}